import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API_BASE,
  withCredentials: true,
});

// Backward-compat token migration: if the old karrar_token key exists but
// the new one doesn't, adopt it so existing signed-in users are not logged out.
try {
  if (!localStorage.getItem("alphacore_token")) {
    const legacy = localStorage.getItem("karrar_token");
    if (legacy) {
      localStorage.setItem("alphacore_token", legacy);
      localStorage.removeItem("karrar_token");
    }
  }
} catch { /* SSR / private mode */ }

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("alphacore_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err?.response?.status === 401 && !err.config?.url?.includes("/auth/me")) {
      // optional: bounce to login
    }
    return Promise.reject(err);
  },
);
